import { BuildPath } from  '@/helpers/Paths';
import { group } from  '@/interfaces/planner';
import React, { useEffect, useRef, useState } from 'react';

const GroupResult = (
    {group, selectedGroups, setSelectedGroups, details}:
    {group:group, selectedGroups:group[], setSelectedGroups:(group:group[])=> void, details?:boolean }) => {

    const [touched, setTouched] = useState<boolean>(false);
    const [highlight, setHighlight] = useState<string>("");

    const isMounted = useRef<boolean>(true)

    useEffect(() => {
        return () => { isMounted.current = false }
    }, [])

    useEffect(() => {

        if (touched){
            const className = !selectedGroups.find(x => x.id === group.id) ? 'removed' : 'added';

            setHighlight(className);

            setTimeout(() => {
                if (isMounted.current){
                    setHighlight("");
                    setTouched(false)
                }
            }, 1500);
        }
        
    }, [touched, selectedGroups])

    return (
        <li key={group.id} className={highlight}>

            <button
                className="select-group"
                aria-label={!selectedGroups.find(x => x.id === group.id) ? `add ${group.groupName}` : `remove ${group.groupName}`}
                onClick={() => {
                    !selectedGroups.find(x => x.id === group.id)
                        ? setSelectedGroups([...selectedGroups, group])
                        : setSelectedGroups([...selectedGroups.filter(x => x.id !== group.id)]); 
                    setTouched(true)
                }} 
            >
                {details 
                    ?   <div className='content-container details'>
                            <div className='profile-container'>
                                <img className="profile" src={`${BuildPath()}/images/planner/users-circle.svg`} alt="" />
                            </div>
                            <div className='title-count'>
                                <h2>{group.groupName}</h2>
                                <span>{group.totalUsersInGroup} members</span>
                            </div>
                        </div>   
                    :   <div className='content-container'>
                            <h2>{group.groupName}</h2>
                        </div>   
                }

                <div className='controls' >
                    {!selectedGroups.find(x => x.id === group.id) 
                        ? <img className='add-remove-icon' src={`${BuildPath()}/images/planner/plus-circle.svg`} alt="" />
                        : <img className='add-remove-icon' src={`${BuildPath()}/images/planner/minus-circle.svg`} alt="" />
                    }
                </div>
            </button>
        </li>
    );
};

export default GroupResult;